import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

const Component = () => {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && (
        <>
          <TanStackRouterDevtools position='bottom-right' />
        </>
      )}
    </>
  );
};

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  // loginStore: {
  //   accessToken: string | null;
  //   parent: Parent | null;
  // };
}>()({
  component: Component,
  notFoundComponent: () => {
    return <p>This page does not exist!</p>;
  },
});
